import { useMutation } from '@apollo/client';
import { useShowToast } from '@application/utils';
import { graphql } from '@gql/gql';
import { useCallback } from 'react';

export const LINK_PRO_CALENDAR_MUTATION = graphql(`
  mutation LinkProCalendarMutation($code: String!) {
    linkProfessionalCalendar(code: $code)
  }
`);

export const useLinkProCalendar = () => {
  const [linkProCalendarMutation, { error: mutationError, loading: mutationLoading, data }] =
    useMutation(LINK_PRO_CALENDAR_MUTATION, {});
  const { showToast } = useShowToast();

  const linkProCalendar = useCallback(
    async ({ code }) => {
      await linkProCalendarMutation({ variables: { code } });
      showToast('Your agenda is now successfully linked with Tipaw!', { type: 'success' });
    },
    [linkProCalendarMutation, showToast],
  );

  return {
    linkProCalendar,
    linkProCalendarLoading: mutationLoading,
    linkProCalendarError: mutationError,
    linkProCalendarData: data,
  };
};
